import React, { useId } from "react";
import "./ProgressBar.css";

/** Wspólny pasek: procent potwierdzony przez usługę albo animacja przy nieznanym postępie. */
export default function ProgressBar({ label, value, description }) {
  const id = useId();
  const percentage = Number.isFinite(value)
    ? Math.max(0, Math.min(100, Math.round(value)))
    : null;
  return (
    <div className="eco-progress">
      <div className="eco-progress-label">
        <span id={id}>{label}</span>
        {percentage !== null && <span aria-hidden="true">{percentage}%</span>}
      </div>
      <div
        className="progress"
        role="progressbar"
        aria-labelledby={id}
        aria-describedby={description ? `${id}-description` : undefined}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percentage ?? undefined}
        aria-valuetext={percentage === null ? "W toku" : `${percentage}%`}
      >
        <div
          className={`progress-bar${percentage === null ? " eco-progress-indeterminate" : ""}`}
          style={percentage === null ? undefined : { width: `${percentage}%` }}
        />
      </div>
      {description && (
        <p id={`${id}-description`} className="eco-progress-description">
          {description}
        </p>
      )}
    </div>
  );
}
